import { useContext, useMemo } from "react";
import { NamedProperty } from "sprint-common-web";

import { SingleAncillaryContext } from "../context/SingleAncillaryContext";
import { useAncillaryAssetsListUrlFilters } from "./useAncillaryAssetsListUrlFilters";
import { useSingleAncillaryDetails } from "./useSingleAncillaryDetails";

export interface VersionDetails {
    versionTypes: NamedProperty[];
    distributors: NamedProperty[];
    airlines: NamedProperty[];
}

export const useAncillaryAssetsListFilters = () => {
    const { ancillary } = useContext(SingleAncillaryContext);

    const {
        filters,
        setStatusIds,
        setPage,
        setPageSize,
        setSort,
        clearFilters,
        setAssetTypes,
        setAssetOrigins,
        setAssetRecordTypes,
        setCreatedDateFrom,
        setCreatedDateTo,
        setUpdatedDateFrom,
        setUpdatedDateTo
    } = useAncillaryAssetsListUrlFilters();

    const { getVersionDetails } = useSingleAncillaryDetails();

    const versionDetails = useMemo<VersionDetails>(() => getVersionDetails(ancillary), [ancillary]);

    const setStatuses = (statusIds: number[]): void => {
        setStatusIds(statusIds);
    };

    return {
        filters,
        versionDetails,
        setStatuses,
        setSort,
        setPage,
        setPageSize,
        clearFilters,
        setAssetTypes,
        setAssetOrigins,
        setAssetRecordTypes,
        setCreatedDateFrom,
        setCreatedDateTo,
        setUpdatedDateFrom,
        setUpdatedDateTo
    };
};
